import React, { Component } from 'react';
import { Button, Input, Select, Icon,DatePicker } from 'antd';
import API_URL from '../../../../../common/url';
import ExportUtil from '../../../../../common/ExportUtil';
import SelectBa from '../../../components/SelectBa';
import moment from 'moment';
import {defaultDate} from "../../../../../common/jsLibs";

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expand: false,
        };
    }

    search = () => {
        this.props.search();
    }

    export = () => {
        const { searchParams } = this.props;
        const defaultDateObj = defaultDate();
        const{beginDateDefault,endDateDefault}=defaultDateObj;
        const{beginDate,endDate}=searchParams;
        searchParams.beginDate=beginDate?beginDate:beginDateDefault;
        searchParams.endDate=endDate?endDate:endDateDefault;  
        const url = API_URL.home.exportApplicationAmountStatistic;
        ExportUtil.export({ ...searchParams }, null, url);
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'customerCompany':
            case 'ba': {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                onChange(searchParams);
                break;
            }
            case 'customerBaName': {
                const { lastLeaf, checkedKeys, expandedKeys } = value;
                searchParams.lastLeaf = lastLeaf;
                searchParams.checkedKeys = checkedKeys;
                searchParams.expandedKeys = expandedKeys;
                searchParams.customerBaNameIds = (lastLeaf || []).map(i => i.id).join(',');
                searchParams.customerBaNameNames = (lastLeaf || []).map(i => i.title).join(',');
                onChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render () {
        const { searchParams, businessList } = this.props;
        const { expand } = this.state;
        const defaultDateObj = defaultDate();
        const{beginDateDefault,endDateDefault}=defaultDateObj;   
        const {
            beginDate = beginDateDefault,
            endDate = endDateDefault,
            lastLeaf, checkedKeys, expandedKeys
        } = searchParams;
        const{curRole}=sessionStorage;

        return (
            <div style={{ marginBottom: 16 }}>
                <div className={`search-bar expand ${expand ? 'expanded' : ''}`}>
                   <div className="search-item">
                        <label htmlFor="" className="ui-label">时间</label>
                        <MonthPicker
                            format={monthFormat}
                            style={{width: 100}}
                            value={beginDate ? moment(beginDate) : null}
                            // disabledDate={this.disabledDate}
                            placeholder="选择月份"
                            allowClear={false}
                            onChange={(date, dateString) => this.handleChange(dateString, 'beginDate')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">至</label>
                        <MonthPicker
                            format={monthFormat}
                            style={{width: 100}}
                            value={endDate ? moment(endDate) : null}
                            placeholder="选择月份"
                            allowClear={false}
                            onChange={(date, dateString) => this.handleChange(dateString, 'endDate')}
                        />
                    </div>
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.export}>导出</Button>
                    </div>
                </div>
                {/* <div className="search-bar flex-end">
                </div> */}
                <SelectBa ref={el => this.selectBaRef = el}
                    lastLeaf={lastLeaf}
                    checkedKeys={checkedKeys}
                    expandedKeys={expandedKeys}
                    onChange={args => this.handleChange(args, 'customerBaName')}
                />
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestAndReturnedSheet/RequestSheet/TablePage/Filter.js